import { useState } from 'react';
import UsersSection from './sections/UsersSection';
import LanguagesSection from './sections/LanguagesSection';
import CategoriesSection from './sections/CategoriesSection';
import SubcategoriesSection from './sections/SubcategoriesSection';
import LyricsSection from './sections/LyricsSection';
import SongsSection from './sections/SongsSection';
import NotificationsSection from './sections/NotificationsSection';
import AppUpdatesSection from './sections/AppUpdatesSection';
import BibleReadingsSection from './sections/BibleReadingsSection';
import OrderOfServiceSection from './sections/OrderOfServiceSection';
import GallerySection from './sections/GallerySection';
import QuoteOfDaySection from './sections/QuoteOfDaySection';
import FeedbackSection from './sections/FeedbackSection';

const TABS = [
  { key: 'users', label: 'Users', Component: UsersSection },
  { key: 'languages', label: 'Languages', Component: LanguagesSection },
  { key: 'categories', label: 'Categories', Component: CategoriesSection },
  { key: 'subcategories', label: 'Subcategories', Component: SubcategoriesSection },
  { key: 'lyrics', label: 'Lyrics', Component: LyricsSection },
  { key: 'songs', label: 'Songs', Component: SongsSection },
  { key: 'notifications', label: 'Notifications', Component: NotificationsSection },
  { key: 'app-updates', label: 'App Updates', Component: AppUpdatesSection },
  { key: 'bible-readings', label: 'Sunday Scripture Reading', Component: BibleReadingsSection },
  { key: 'order-of-service', label: 'Order of Service', Component: OrderOfServiceSection },
  { key: 'gallery', label: 'Gallery', Component: GallerySection },
  { key: 'quote-of-the-day', label: 'Quote of the Day', Component: QuoteOfDaySection },
  { key: 'feedback', label: 'Feedback', Component: FeedbackSection },
];

export default function Dashboard({ token, user, onLogout }) {
  const [activeTab, setActiveTab] = useState('users');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const ActiveComponent = TABS.find((tab) => tab.key === activeTab).Component;

  const selectTab = (key) => {
    setActiveTab(key);
    setSidebarOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 md:flex">
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-30 md:hidden"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <aside
        className={`fixed inset-y-0 left-0 z-40 w-64 max-w-[80vw] bg-white border-r border-gray-200 flex flex-col transform transition-transform duration-200 ease-in-out md:static md:z-auto md:w-56 md:max-w-none md:translate-x-0 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="px-4 py-5 border-b border-gray-200">
          <h1 className="text-lg font-semibold text-gray-900">Gospel Lyrics</h1>
          <p className="text-xs text-gray-500 mt-0.5">Admin dashboard</p>
        </div>
        <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => selectTab(tab.key)}
              className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                activeTab === tab.key
                  ? 'bg-indigo-50 text-indigo-700'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
        <div className="px-4 py-4 border-t border-gray-200">
          <p className="text-sm text-gray-700 truncate">{user.name}</p>
          <button
            onClick={onLogout}
            className="mt-2 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
          >
            Log out
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0 flex flex-col min-h-screen">
        <header className="md:hidden sticky top-0 z-20 flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-200">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-1 -ml-1 text-gray-600"
            aria-label="Open menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <h1 className="text-base font-semibold text-gray-900">Gospel Lyrics</h1>
        </header>
        <main className="flex-1 p-4 md:p-8 overflow-y-auto min-w-0">
          <ActiveComponent token={token} />
        </main>
      </div>
    </div>
  );
}
